import { SimplePageLayout, SimplePageContentWrapper } from '@flexinet/ui-components';
import { AliasesPageHeader } from '../components/AliasesPageHeader';
import { AliasesPageNavigation } from '../navigation/AliasesPageNavigation';
import { AliasesTable } from '../tables/AliasesTable';

export const AliasesManagementPage = () => {
    return (
        <SimplePageLayout
            pageHeader={<AliasesPageHeader />}
            pageNavigation={<AliasesPageNavigation />}
        >
            <SimplePageContentWrapper>
                <AliasesTable />
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
